module.exports = __webpack_public_path__ + "static/media/setupProfileThumbnail.27287390.png";